import styled from 'styled-components';
import { Modal, Button } from '@prosolve/common-components-ui'
import { FaExclamationTriangle } from "react-icons/fa";

const Content = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 16px;
  color: #565656;
  width: 400px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: normal;
  font-family: "PassionOne-Regular", "Open Sans", sans-serif;
`

const Title = styled.div`
  font-size: 22px;
`

const Description = styled.div`
  font-family: "PassionOne-Regular", "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: normal;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

export default ({
  onClose,
  onConfirmation
}) => {

  const TitleComponent = (
    <Header>
      <FaExclamationTriangle style={{ color: '#F88700', marginRight: '10px', fontSize: '22px' }} />
      <Title>
        {'Confirm you wish to replay this challenge.'}
      </Title>
    </Header>
  )

  const baseButtonStyle = {
    padding: '10px',
    fontSize: '18px',
    borderRadius: '10px',
    fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
  }

  const FooterComponent = (
    <ButtonsContainer>
      <Button style={baseButtonStyle} $colored={true} onClick={onConfirmation}>
        {'Confirm'}
      </Button>
      {/* <Button style={{ ...baseButtonStyle, fontWeight: 'bold' }} onClick={onPracticeEpisodeConfirmation} $colored={true}>
        {'PROCEED WITHOUT SAVING'}
      </Button> */}
    </ButtonsContainer>
  )

  return (
    <Modal title={TitleComponent} footer={FooterComponent} isFullScreen={false} isAutoHeight={true} isAutoWidth={true} closeOnOffClick={true} onClose={onClose}>
      <Content>
        <Description>
          {'All of your previous progress will be lost.'}
        </Description>
      </Content>
    </Modal>
  )
}